import React from 'react';

export default ({id, name, selected, onClick}) => (
	<p 
        className={selected ? 'item item-selected' : 'item'}
        onClick={() => onClick(id)}
    >
        {name}
    </p>
)


// WEBPACK FOOTER //
// ./src/components/Item.js